/**
 * @Author: v_jppjpeng
 * @Date: 2023-2-21 15:43:12
 * @Explain: 设置 - 验证邮箱管理
 */
import http from '../http';
import { ListResponse } from './data.d';

const MODEL = '/task';

export default {
  // 列表
  getList(data: Record<any, any>): Promise<ListResponse> {
    return http.post(`${MODEL}/get-verify-email-list`, data, {
      params: { isPackage: 'N' },
    });
  },
  // 添加、编辑
  onAddOrEdit(data: Record<any, any>) {
    return http.post(`/settings/save-email-message`, data);
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`/settings/batch-del`, data);
  },
};
